module.exports = __webpack_public_path__ + "static/content_text_updates_2_do-ddb17203cf824d49464fba5a9399cec7.png";